import { useEditorState } from "./useEditorState";
import { usePageFromCurrentRoute } from "./usePageFromCurrentRoute";
import { useRouteParams } from "./useRouteParams";

export function useEditorStateForCurrRoute() {
	const { documentId } = useRouteParams();
	const { pageMetadata } = usePageFromCurrentRoute();

	return useEditorState(documentId, pageMetadata ? pageMetadata.id : "");
}
